<template>
  <div class="page-cursos">

    <div v-if='displayCourses.length > 0' class="filter-block">

      <div>
        <input @keypress="checkEnterPressed" :placeholder="$config.strings['eBook-formField-1']" v-model="filterParam.keyword" />
        <a @click="doFilter('byKeyword')"><span class="material-icons">search</span></a>
      </div>

      <div>
        <select @change="doFilter('byCategory')" :placeholder="$config.strings['eBook-formField-2']" v-model="filterParam.category">
          <option value='' v-html="$config.strings['eBook-formField-2']" />
          <option v-for="categoria in cursos" :key="JSON.stringify(categoria)" v-bind:value="categoria.categoria" v-html="categoria.categoria" />
        </select>
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="var(--on-primary)" d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
        </svg>
      </div>

      <div>
        <select @change="doFilter('orderBy')" :placeholder="$config.strings['eBook-formField-3']" v-model="filterParam.orderBy">
          <option value="A|Z">Ordenar por A|Z</option>
          <option value="Z|A">Ordenar por Z|A</option>
        </select>
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="var(--on-primary)" d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
        </svg>
      </div>

    </div>

    <h1 class="page-title" v-html="$config.strings['eBook-title']"/>
    <div class="page-description" v-html="$config.strings['eBook-description']"/>

    <template v-if="loading">
      <div class="loading-container">
        <t-spinner />
      </div>
    </template>

    <template v-else>
    <template v-for="categoria in displayCourses">
      <div class="course-category" :key="JSON.stringify(categoria)" v-if="categoria.cursos.length > 0">
        <h1 class="categoria-title" v-html="categoria.categoria"/>
        <t-hs-list :items="categoria.cursos" @click="showDetail"/>
      </div>
    </template>

    <div v-bind:class="keywordSearchClass">
      <div class="result-status">
        <span><span v-html="keywordFound.length" /> resultado(s) para "<span v-html="filterParam.keyword" />"</span>
        <a class="result-close-btn" @click="resetSearch" />
      </div>
      <t-hs-list :items='keywordFound' :noScroll='true' :noSpaceBefore='true' @click='showDetail' />
    </div>
    </template>

    <t-detail ref="detail" :loading="loading" :detail="detail" :error="detailError"/>
  </div>
</template>

<script>
import { THSList, TDetail, TSpinner } from '@/components/base'
import { mapActions, mapState } from 'vuex'
import _sortBy from 'lodash/sortBy'
import _map from 'lodash/map'
import _flatten from 'lodash/flatten'

export default {
  name: 'page-cursos',
  components: { [THSList.name]: THSList, TDetail, TSpinner },
  data () {
    return {
      loading: false,
      detailError: '',
      lastContentHeight: '0px',
      displayCourses: [],
      keywordFound: [],
      keywordApplied: false,
      filterParam: {
        keyword: '',
        category: '',
        orderBy: 'A|Z'
      },
      filters: {
        reset: () => {
          this.keywordApplied = false
          this.keywordFound = []
        },
        byKeyword: () => {
          const target = this.filterParam.keyword
          const array = _flatten(_map([].concat(this.cursos), (category) => category.cursos))

          if (!target) return array

          this.keywordFound = array.filter(({ nome }) => new RegExp(target, 'gi').test(nome))
          this.keywordApplied = true
          window.addEventListener('keyup', this.resetWithESC, true)

          return this.displayCourses
        },
        byCategory: () => {
          const target = this.filterParam.category
          const array = [].concat(this.cursos)

          if (!target) return array

          return [array.find(({ categoria }) => categoria === target)]
        },
        orderBy: () => {
          const mode = this.filterParam.orderBy
          return ([].concat(this.cursos)).map((category) => {
            return ({ ...category, cursos: mode === 'Z|A' ? _sortBy(category.cursos, ['nome']).reverse() : _sortBy(category.cursos, ['nome']) })
          })
        }
      }
    }
  },
  computed: {
    ...mapState({
      cursos: state => state.cursos[1],
      detail: state => state.detail
    }),
    keywordSearchClass () {
      return `result-searched-keyword${this.$data.keywordApplied ? ' show-search' : ''}`
    }
  },
  methods: {
    ...mapActions(['getCursos', 'getDetail']),
    showDetail (activeCard, curso) {
      this.detailError = ''
      const t = setTimeout(() => {
        this.loading = true
      }, 250)
      this.$refs.detail.show(activeCard)
      if (this.$refs.content) {
        this.lastContentHeight = `${this.$refs.content.$el.getBoundingClientRect().height}px`
      }
      this.getDetail(curso.id).catch(error => {
        if (error.response.status === 404) {
          this.detailError = 'Ocorreu algum erro ao carregar os detalhes do curso, tente novamente mais em alguns instantes'
        }
      }).finally(() => {
        clearTimeout(t)
        this.loading = false
      })
    },
    doFilter (type) {
      const filterFound = this.filters[type]
      this.displayCourses = filterFound()
    },
    resetSearch () {
      this.filters.reset()
      window.removeEventListener('keyup', this.resetWithESC, true)
    },
    checkEnterPressed (event) {
      event.keyCode === 13 && this.doFilter('byKeyword')
    },
    resetWithESC (event) {
      if (event.key === 'Escape') {
        this.filters.reset()
      }
    }
  },
  mounted () {
    this.loading = true
    this.getCursos().finally(() => {
      this.displayCourses = _map(this.cursos, (category) => ({
        ...category, cursos: _sortBy(category.cursos, ['nome'])
      }))
      this.loading = false
    })
  }
}
</script>

<style lang="scss" scoped>
.page-cursos {
  padding: 16px initial !important;
  position: relative;

  .page-title {
    @include container-element;
  }

  .page-description {
    @include container-element;
  }

  .loading-container {
    @include container-element;
    padding-top: 50px;

    > * {
      display: block;
      margin: 0 auto;
    }
  }

  .course-category {
    padding-top: 25px;

    .categoria-title {
      @include container-element;
      padding-bottom: 0px;
      color: var(--on-background);
      font-size: 14px;
      font-weight: 700;
    }

    @include for-size(desktop-up) {
      padding-top: 40px;
      padding-bottom: 20px;

      .categoria-title {
        padding-bottom: 15px;
        font-size: 22px;
        font-weight: 600;
      }
    }
  }

  .page-description + .course-category {
    padding-top: initial;
  }

  .filter-block {
    @include container-element;
    padding-top: 25px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
    color: var(--on-primary);
    overflow-x: auto;

    @include for-size(phone-only) {
      justify-content: space-between;
      flex-wrap: wrap;
    }

    > * {
      display: inline-block;
      position: relative;
      width: auto;
      padding-left: 15px;

      > select {
        padding-right: 30px;
        appearance: none;
        -webkit-appearance: none;
      }

      > * {
        background-color: var(--primary);
        color: var(--on-primary);
        border: none;
        padding: 10px 15px;
        border-radius: 4px;
      }

      > svg {
        background: transparent;
        padding: 0;
        position: absolute;
        right: 4px;
        top: 6px;
        pointer-events: none;
      }

      &:first-child {
        padding-left: initial;

        > input {
          padding-right: 35px;
          &::placeholder {
            color: var(--on-primary);
            opacity: 0.5;
          }
        }

        > a {
          position: absolute;
          display: inline-block;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          padding: initial;
          cursor: pointer;
          padding-right: 5px;
          padding-top: 5px;
        }
      }

      @include for-size(phone-only) {
        padding-left: initial;
        width: 50%;

        > * {
          max-width: 100%;
        }

        &:first-child {
          width: 100%;
          padding-bottom: 10px;

          > input {
            width: 100%;
            &::placeholder {
              color: var(--on-primary);
              opacity: 0.5;
            }
          }

          > a {
            transform: initial;
            top: 5px;
            padding-top: initial;
            background: initial;
          }
        }

        &:last-child {
          padding-left: 10px;
        }
      }
    }
  }

  .result-searched-keyword {
    @include container-element;
    transition: all 1s;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: none;
    overflow: auto;
    z-index: 2;
    background-color: var(--secondary-light);

    &.show-search {
      display: block;
      animation: searchOn 0.7s 1;
    }

    .result-status {
      padding: 10px 0;
      color: var(--on-secondary-light);
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      position: relative;
      font-weight: 600;

      > span {
        width: 100%;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 15px;

        > span:first-child {
          padding-right: 5px;
        }
      }

      .result-close-btn {
        color: var(--on-secondary);
        background-color: var(--secondary);
        border-radius: 20px;
        padding: 5px 10px;
        cursor: pointer;
        display: inline-block;
        top: 10px;
        right: 0;

        &::before {
          content: "X";
          white-space: nowrap;
        }
      }

      @include for-size(tablet-portrait-up) {
        padding: 25px 0;

        .result-close-btn {

          top: 15px;
          font-size: 12px;

          > span {
            vertical-align: middle;
          }

          &::before {
            content: "Fechar pesquisa";
          }
        }
      }
    }
  }
}
@keyframes searchOn {
  from { opacity: 0 }
  to { opacity: 1 }
}
</style>
